{
  "whatsapp_business_api_agent_page": {
    "template_langs": {
      "af": "Africâner",
      "sq": "Albanês",
      "ar": "Árabe",
      "az": "Azerbaijano",
      "bn": "Bengali",
      "bg": "Búlgaro",
      "ca": "Catalão",
      "zh_CN": "Chinês (CHN)",
      "zh_HK": "Chinês (HKG)",
      "zh_TW": "Chinês (TAI)",
      "hr": "Croata",
      "cs": "Tcheco",
      "da": "Dinamarquês",
      "nl": "Holandês",
      "en": "Inglês",
      "en_GB": "Inglês (UK)",
      "en_US": "Inglês (EUA)",
      "et": "Estoniano",
      "fil": "Filipino",
      "fi": "Finlandês",
      "fr": "Francês",
      "ka": "Georgiano",
      "de": "Alemão",
      "el": "Grego",
      "gu": "Gujarati",
      "ha": "Hausa",
      "he": "Hebraico",
      "hi": "Hindi",
      "hu": "Húngaro",
      "id": "Indonésio",
      "ga": "Irlandês",
      "it": "Italiano",
      "ja": "Japonês",
      "kn": "Canarês",
      "kk": "Cazaque",
      "rw_RW": "Quiniaruanda",
      "ko": "Coreano",
      "ky_KG": "Quirguiz (Quirguistão)",
      "lo": "Laosiano",
      "lv": "Letão",
      "lt": "Lituano",
      "mk": "Macedônio",
      "ms": "Malaio",
      "ml": "Malaiala",
      "mr": "Marata",
      "nb": "Norueguês",
      "fa": "Persa",
      "pl": "Polonês",
      "pt_BR": "Português (BR)",
      "pt_PT": "Português (POR)",
      "pa": "Punjabi",
      "ro": "Romeno",
      "ru": "Russo",
      "sr": "Sérvio",
      "sk": "Eslovaco",
      "sl": "Esloveno",
      "es": "Espanhol",
      "es_AR": "Espanhol (ARG)",
      "es_ES": "Espanhol (ESP)",
      "es_MX": "Espanhol (MEX)",
      "sw": "Suaíli",
      "sv": "Sueco",
      "ta": "Tâmil",
      "te": "Telugo",
      "th": "Tailandês",
      "tr": "Turco",
      "uk": "Ucraniano",
      "ur": "Urdu",
      "uz": "Uzbeque",
      "as": "Assamês",
      "hne": "Chhattisgarhi",
      "km": "Khmer",
      "mni_Mtei": "Meiteilon (Manipuri)",
      "or": "Oriá",
      "ps": "Pashto",
      "so": "Somali",
      "vi": "Vietnamita",
      "yo": "Iorubá",
      "zu": "Zulu"
    },
    "upload_types": {
      "documents": "Documentos",
      "photos_and_videos": "Fotos & Vídeos",
      "camera": "Câmera",
      "location": "Localização"
    },
    "drop_files": "Solte arquivos",
    "file_exeeds_limit": "Falha ao carregar arquivo: {{fileName}}. O tamanho do arquivo excede o limite{{maxFileSize}}",
    "no_preview_available": "Pré-visualização não disponível",
    "chats_filters_title": "FILTRAR CONVERSAS",
    "phone": "Telefone",
    "first_name": "Nome",
    "last_name": "Sobrenome",
    "save": "Salvar",
    "failed_to_start_new_chat": "Falha ao iniciar nova conversa. Por favor, tente novamente.",
    "failed_to_add_contact": "Falha ao adicionar contato. Por favor, tente novamente.",
    "failed_to_add_contact_phone_number_already_exists": "Não foi possível adicionar contato: O número de telefone fornecido já existe em nossos registros. Por favor, verifique o número digitado com precisão ou considere atualizar os detalhes de contato existentes.",
    "failed_to_add_contact_to_contacts": "Falha ao adicionar conversa ao contato. Por favor, tente novamente.",
    "failed_to_update_contact": "Falha ao atualizar contato. Por favor, tente novamente.",
    "failed_to_update_contact_phone_number_already_exists": "Não foi possível atualizar contato: O número de telefone que você digitou já existe em nossos registros. Por favor, garanta que o número de telefone seja único ou considere editar o contato existente.",
    "failed_to_archive_contact": "Falha ao arquivar contato. Por favor, tente novamente.",
    "failed_to_archive_chat": "Falha ao arquivar conversa. Por favor, tente novamente.",
    "failed_to_unarchive_contact": "Falha ao desarquivar contato. Por favor, tente novamente.",
    "failed_to_unarchive_chat": "Falha ao desarquivar conversa. Por favor, tente novamente.",
    "failed_to_send_message": "Falha ao enviar mensagem. Por favor, tente novamente.",
    "empty_state_message": "Comece a conversar instantaneamente clicando em qualquer conversa",
    "contacts_empty_state_message": "Selecione um contato para começar a gerenciar sua lista de contatos",
    "nav_options": {
      "chats": "Conversas",
      "active_chats": "Conversas ativas",
      "archived": "Conversas arquivadas",
      "unknown": "Conversas desconhecidas",
      "contacts": "Contatos",
      "campaigns": "Campanhas"
    },
    "send_templates_to_many": {
      "sendingTemplates": "Enviando templates...",
      "failedToSendTemplates": "Falha ao enviar templates",
      "templatesSent": "Templates enviados",
      "failedToSendToChats": "Templates enviados\nFalha ao enviar para - {{numberOfFailed}} clientes"
    },
    "bulk_send": {
      "title": "Envio em Massa de Mensagens",
      "bulk_send_tooltip": "Envio em massa de mensagens para números de telefone a partir de CSV",
      "step_1_upload": "Carregar Números de Telefone",
      "step_1_template": "Passo 1: Selecionar Template",
      "step_2_phone": "Passo 2: Selecionar Telefone Remetente",
      "step_2_options": "Opções",
      "step_3_select_phone": "Selecionar Telefone",
      "step_3_csv": "Passo 3: Carregar CSV",
      "step_4_template": "Selecionar Template",
      "step_4_media": "Passo 4: Carregar Cabeçalho {{type}}",
      "instructions": "Carregue um arquivo CSV com números de telefone para enviar mensagens.",
      "download_template": "Baixar Template CSV",
      "drop_csv": "Arraste o arquivo CSV aqui ou clique para navegar",
      "drop_media": "Arraste o arquivo {{type}} aqui ou clique para navegar",
      "phone_number": "Número de Telefone",
      "first_name": "Primeiro Nome",
      "last_name": "Sobrenome",
      "preview": "Prévia (mostrando as primeiras 5 linhas)",
      "add_to_contacts": "Adicionar números de telefone aos Contatos",
      "select_phone": "Selecione um número de telefone para enviar",
      "select_template": "Selecione um template para enviar",
      "send_messages": "Enviar Mensagens",
      "create_campaign": "Criar Campanha",
      "no_whatsapp_phones": "Nenhum telefone WhatsApp disponível. Por favor, configure um telefone WhatsApp primeiro.",
      "sending_messages": "Enviando mensagens...",
      "all_messages_sent": "Todas as {{count}} mensagens foram enviadas com sucesso!",
      "all_messages_failed": "Falha ao enviar todas as mensagens",
      "partial_success": "{{successCount}} mensagens enviadas, {{failedCount}} falharam",
      "send_failed": "Falha ao enviar mensagens. Por favor, tente novamente.",
      "csv_errors": {
        "empty_file": "O arquivo CSV está vazio",
        "missing_required_headers": "O arquivo CSV não possui cabeçalhos obrigatórios: {{missingRequiredHeaders}}",
        "invalid_headers": "O arquivo CSV contém cabeçalhos inválidos: {{invalidHeaders}}",
        "invalid_phones": "O arquivo CSV contém números de telefone inválidos: {{invalidPhones}}",
        "too_many_rows": "O arquivo CSV contém {{rowCount}} linhas, mas o máximo permitido é {{maxRows}} linhas",
        "missing_template_params": "O arquivo CSV não possui colunas de parâmetros do template: {{params}}"
      },
      "cancel": "Cancelar",
      "required": "Obrigatório",
      "optional": "Opcional",
      "phone_description": "Todos os números de telefone válidos receberão mensagens",
      "first_name_description": "Usado para criação de contatos",
      "last_name_description": "Usado para criação de contatos",
      "contact_note": "Nota: Apenas entradas com Nome e Sobrenome serão adicionadas como contatos quando \"Adicionar aos contatos\" estiver habilitado.",
      "contacts_to_add": "{{count}} contatos serão adicionados",
      "campaign_name": "Nome da Campanha",
      "campaign_name_placeholder": "Digite um nome para esta campanha",
      "media_type_mismatch": "Por favor, envie um arquivo {{expected}}",
      "summary": "Resumo",
      "summary_rows": "{{count}} destinatários",
      "summary_template": "Template: {{name}}",
      "summary_phone": "De: {{phone}}",
      "campaign_created": "Campanha criada!",
      "campaign_error": "Falha ao criar campanha"
    },
    "campaigns": {
      "title": "Campanhas",
      "loading": "Carregando campanhas...",
      "loading_items": "Carregando itens...",
      "no_campaigns": "Ainda não há campanhas. Crie uma campanha de envio em massa para começar.",
      "no_items": "Nenhum item encontrado",
      "no_search_results": "Nenhuma campanha encontrada",
      "search_placeholder": "Pesquisar campanhas...",
      "select_campaign": "Selecione uma campanha para ver os detalhes",
      "back_to_list": "Voltar para campanhas",
      "back": "Voltar",
      "total": "Total",
      "success": "Sucesso",
      "failed": "Falhou",
      "pending": "Pendente",
      "all": "Todos",
      "phone": "Telefone",
      "first_name": "Primeiro Nome",
      "last_name": "Sobrenome",
      "status": "Status",
      "error": "Erro",
      "export": "Exportar",
      "template": "Template",
      "sender": "Remetente",
      "created": "Criado",
      "add_campaign_tooltip": "Adicionar campanha"
    },
    "labels": {
      "add_labels": "Adicionar etiquetas",
      "select_contacts_to_add_labels": "Selecionar contatos para adicionar etiquetas",
      "modal": {
        "header": "Selecionar etiquetas",
        "failed_to_add_labels_to_selected_chats": "Falha ao adicionar etiquetas aos chats selecionados",
        "succeed_to_add_labels_to_selected_chats": "Etiquetas adicionadas aos chats selecionados com sucesso"
      }
    },
    "filters": {
      "all": "Todos",
      "unassigned": "Não atribuído",
      "assigned_to_me": "Atribuído a mim"
    },
    "status": {
      "label": "Status",
      "open": "Aberto",
      "pending": "Pendente",
      "bot": "Bot",
      "closed": "Fechado",
      "update_success": "Status atualizado com sucesso",
      "update_failed": "Falha ao atualizar status"
    },
    "assign_agent": {
      "placeholder": "Atribuir agente...",
      "no_agents": "Nenhum agente disponível",
      "search_placeholder": "Buscar agentes...",
      "assigned": "Atribuído",
      "update_success": "Atribuição de agente atualizada",
      "update_failed": "Falha ao atualizar atribuição de agente"
    },
    "opt_in": {
      "send": {
        "message1": "Você iniciou uma solicitação de aceitação com o contato.",
        "message2": "Assim que o contato aceitar, você poderá começar a enviar mensagens."
      },
      "no_send": {
        "message1": "Você ainda não iniciou uma solicitação de aceitação com o contato.",
        "message2": "Se quiser enviar o template de aceitação, clique",
        "here": "aqui"
      },
      "modal": {
        "message1": "Esta ação requer aprovação do contato para iniciar a comunicação pelo WhatsApp.",
        "message2": "Você tem certeza de que deseja enviar a solicitação de permissão?",
        "template_name": "Nome do template:",
        "template_lang": "Idioma do template:",
        "header": "Solicitar permissão do cliente",
        "send_template_header": "Selecionar template para enviar",
        "param_required": "Este campo é obrigatório",
        "param_too_long": "Máximo de {{max}} caracteres permitidos",
        "enter_param_value": "Digite o valor para {{{{index}}}}",
        "assign_conversation_to_me": "Atribuir conversa a mim",
        "set_conversations_status_to_open": "Definir status da conversa como aberta",
        "image_header": "Cabeçalho de Imagem",
        "video_header": "Cabeçalho de Vídeo",
        "document_header": "Cabeçalho de Documento",
        "upload_image": "Enviar imagem:",
        "upload_video": "Enviar vídeo:",
        "upload_document": "Enviar documento:",
        "drop_or_click": "Arraste e solte ou clique para enviar",
        "file_too_large": "O tamanho do arquivo excede o limite ({{maxSize}})",
        "invalid_file_type": "Tipo de arquivo inválido. Esperado {{expected}}",
        "file_required": "Por favor, envie um arquivo para o cabeçalho de mídia"
      }
    },
    "add_contact_modal": {
      "add_contact_title": "Adicionar contato",
      "edit_contact_title": "Editar contato"
    },
    "chat_list": {
      "header": "Conversas",
      "add_chat_tooltip": "Selecionar contato",
      "search_contact_placeholder": "Pesquisar...",
      "no_search_results": "Nenhuma conversa encontrada",
      "no_contacts": "Clique na opção '+' para selecionar ou adicionar um contato e começar a conversar",
      "select_contact_to_send_template": "Selecionar contatos para enviar o template",
      "cancel_select_contact_to_send_template": "Cancelar seleção de contatos",
      "add_contact_via_csv": "Adicionar contato via CSV"
    },
    "select_contact_modal": {
      "title": "Selecionar contato",
      "search_placeholder": "Pesquisar contato",
      "no_contact": "Para começar a conversar, clique na opção '+' para adicionar um contato.",
      "no_results": "Não encontramos nada",
      "chat_from": "Conversar com {{number}}"
    },
    "contact_list": {
      "header": "Conversas",
      "add_contact_tooltip": "Adicionar contato",
      "search_contact_placeholder": "Pesquisar...",
      "no_search_results": "Nenhum contato encontrado",
      "no_contacts": "Clique na opção '+' para adicionar contato"
    },
    "message_panel": {
      "text_placeholder": "Digite uma mensagem"
    },
    "configuration_missing_message1": "Configuração incompleta do WhatsApp Business API",
    "configuration_missing_message2": "Por favor, entre em contato com seu administrador para completar a configuração",
    "smarters_token_missing_message1": "O token do Smarters não está configurado",
    "smarters_token_missing_message2": "Por favor, entre em contato com seu administrador para configurar o token do Smarters para seu telefone do WhatsApp Business API",
    "archive_contact": {
      "message1": "Você tem certeza de que deseja arquivar o contato '{{name}}'?",
      "message1_multiple": "Tem certeza de que deseja arquivar {{num_of_items}} contactos?",
      "message2": "Arquivar removerá o contato da sua lista ativa. No entanto, seu histórico de conversas passadas será preservado.",
      "archive": "Arquivar",
      "unarchive": "Desarquivar",
      "unarchive_message": "Você tem certeza de que deseja desarquivar o contato '{{name}}'?",
      "title": "Arquivar contacto"
    },
    "archive_chat": {
      "message1": "Você tem certeza de que deseja arquivar a conversa '{{name}}'?",
      "message1_multiple": "Tem certeza de que deseja arquivar {{num_of_items}} conversas?",
      "message2": "Arquivar removerá a conversa da sua lista ativa. No entanto, seu histórico de conversas passadas será preservado.",
      "archive": "Arquivar",
      "unarchive": "Desarquivar",
      "unarchive_message": "Você tem certeza de que deseja desarquivar a conversa '{{name}}'?",
      "unarchive_message_multiple": "¿Está seguro de que desea desarchivar {{num_of_items}} chats?",
      "title": "Arquivar conversa"
    },
    "add_to_contacts": "Adicionar aos contatos",
    "contact_details": "Detalhes do contato",
    "convert_unknown_contact": "Marcar contato como conhecido",
    "convert_unknown_contact_modal_message": "Você tem certeza de que deseja marcar '{{name}}' como conhecido?",
    "create_new_contact": "Criar novo contato",
    "add_to_existing_contact": "Adicionar a contato existente",
    "chat_from_dialog": {
      "title": "Selecione o canal para conversar"
    },
    "selected_chats": "Chats selecionados",
    "send_template": "Enviar template",
    "send_location_permissions_decline": "As permissões de localização devem ser concedidas para enviar a localização",
    "failed_to_import_contacts_from_csv": "Falha ao importar contatos do arquivo CSV",
    "contacts_imported_successfully": "Contatos importados com sucesso"
  },
  "no_results": "Sem resultados",
  "waba_errors": {
    "title": "Falha na Entrega da Mensagem",
    "unknown": "Esta mensagem não pôde ser entregue.",
    "generic_error": "Sua mensagem não pôde ser entregue (Erro {{errorCode}}).",
    "media_download_error": "O tipo de arquivo não é suportado. Por favor, tente um formato diferente.",
    "media_file_size_too_big": "O tamanho do arquivo excede o limite. Por favor, tente um arquivo menor.",
    "media_type_not_supported": "O tipo de mídia não é suportado para este tipo de mensagem.",
    "media_download_failed": "Falha ao baixar o arquivo de mídia. Por favor, tente novamente.",
    "rate_limit_hit": "A mensagem não foi entregue devido a limites de taxa. Por favor, tente novamente mais tarde.",
    "message_limit_exceeded": "Você excedeu o limite de mensagens para este número de telefone.",
    "business_restricted": "A empresa está restrita de enviar mensagens.",
    "template_param_count_mismatch": "O número de parâmetros do modelo não corresponde ao modelo.",
    "template_not_found": "O modelo não existe ou não foi aprovado.",
    "template_content_mismatch": "O conteúdo do modelo não corresponde ao modelo aprovado.",
    "template_paused": "O modelo foi pausado devido à baixa classificação de qualidade.",
    "template_disabled": "O modelo está desabilitado.",
    "template_params_invalid": "Os parâmetros do modelo estão faltando ou são inválidos.",
    "template_quality_low": "A qualidade do modelo é muito baixa para enviar.",
    "invalid_recipient": "O destinatário não é um usuário válido do WhatsApp.",
    "recipient_not_in_allowed_list": "Este número de telefone não está na lista permitida da sua conta do WhatsApp.",
    "user_not_opted_in": "Esta mensagem não pôde ser entregue porque o cliente não deu consentimento.",
    "outside_24h_window": "A mensagem não pôde ser enviada porque foi enviada fora da janela de 24 horas.",
    "cloud_api_rate_limit": "Limite de taxa da API do WhatsApp Cloud atingido. Por favor, tente novamente mais tarde.",
    "internal_error": "Algo deu errado nos servidores do WhatsApp. Por favor, tente novamente.",
    "access_denied": "Acesso negado. Por favor, verifique as permissões.",
    "account_locked": "A conta comercial está bloqueada ou restrita.",
    "message_too_old": "A mensagem não pôde ser enviada. A mensagem pode ser muito antiga.",
    "message_type_not_supported": "O tipo de mensagem não é suportado.",
    "recipient_blocked": "O destinatário bloqueou mensagens desta empresa.",
    "required_parameter_missing": "Um parâmetro obrigatório está faltando na solicitação.",
    "parameter_value_invalid": "Um valor de parâmetro não é válido.",
    "phone_number_not_registered": "O número de telefone não está registrado para WhatsApp Business.",
    "unsupported_message": "Este tipo de mensagem não é suportado.",
    "display_name_approval_required": "A aprovação do nome de exibição é necessária antes de enviar mensagens.",
    "temporarily_unavailable": "O WhatsApp está temporariamente indisponível. Por favor, tente novamente mais tarde.",
    "user_experiment": "Esta mensagem não pôde ser enviada devido a uma restrição de experimento do usuário.",
    "phone_number_reverification_needed": "É necessária a reverificação do número de telefone."
  },
  "resend_message": {
    "message_not_synced": "A mensagem ainda não foi sincronizada, tente novamente em alguns minutos",
    "message_file_not_found": "Não conseguimos encontrar o arquivo da mensagem, tente escrever uma nova mensagem com o mesmo arquivo e texto",
    "cannot_send_empty_text": "Não é possível enviar mensagem de texto sem texto",
    "resend_message": "Reenviar mensagem",
    "confirm_resend_message": "Tem certeza de que deseja reenviar esta mensagem?",
    "cannot_resend_message": "Tuvis não pôde reenviar a mensagem, por favor tente novamente mais tarde",
    "message_resent": "A mensagem foi reenviada"
  }
}